import { useContext } from "react";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

import { FirebaseContext, FIREBASE_REGION } from "./context";

import {
  CallableFunctionId,
  HTTPFunctionResponse,
  FunctionResponse,
} from "@msend/types";

/**
 * Checks if a Firebase app has been initialised.
 */
export const useFirebase = () => useContext(FirebaseContext).initialised;

/**
 * Returns the Firebase Auth instance.
 */
export const useAuth = () => {
  if (useFirebase()) return getAuth();
};

/**
 * Returns the Firebase Firestore instance.
 */
export const useFirestore = () => {
  if (useFirebase()) return getFirestore();
};

/**
 * Returns the Firebase Storage instance.
 */
export const useStorage = () => {
  if (useFirebase()) return getStorage();
};

/**
 * Returns a HTTPs callable Firebase function with the specified name.
 *
 * @param name the name of the Firebase function
 */
export const useFunction = <T, R = FunctionResponse>(name: CallableFunctionId) => {
  if (useFirebase())
    return httpsCallable(getFunctions(getApp(), FIREBASE_REGION), name) as (
      data?: T
    ) => Promise<HTTPFunctionResponse<R>>;
};
